import React from 'react';
import Header from "./header";
import AboutMe from "./about-me";
import AboutCourse from "./about-course";
import {packageInfo} from "../data/mock-date";
import Package from "./packeges";
import MiniHeaders from "./mini-headers";
import HowRegister from "./how-register";
import OtherServices from "./other-services";

const MainPage = () => {
    return (
        <div>
            <Header/>
            <div className={'wrapper-main-content'}>
                <AboutCourse/>
                <AboutMe/>
                <div className={'blocks-wrapper'}>
                    <MiniHeaders headerName={'Փաթեթներ'}/>
                    {
                        packageInfo.map((item, index) => {
                            return (
                                <Package key={index} packageObj={item}/>
                            )
                        })
                    }

                </div>
                <HowRegister/>
                <OtherServices/>
            </div>
        </div>
    );
};

export default MainPage;
